import { contentOptimizerKeywordSource } from '../../constants/contentOptimizerKeywordSource';
import { optimizerKeywordsSortKeys } from '../../constants/optimizerKeywordsSortItems';

export const isMainKeywordSource = (source = '') => source === contentOptimizerKeywordSource.main;

export const isCustomKeywordSource = (source = '') =>
    source === contentOptimizerKeywordSource.custom;

export const getSortedOptimizerKeywords = (keywords, sortKey) => {
    const mainKeyword = keywords.find((keyword) => isMainKeywordSource(keyword.source));
    const mainKeywordList = mainKeyword ? [mainKeyword] : [];
    const sortedByImportanceKeywords = keywords.sort((a, b) => b.importance - a.importance);
    let sortedKeywords;

    switch (sortKey) {
        case optimizerKeywordsSortKeys.importance:
            sortedKeywords = mainKeywordList.concat(
                sortedByImportanceKeywords.filter((keyword) => !isMainKeywordSource(keyword.source))
            );
            break;

        case optimizerKeywordsSortKeys.heading:
            sortedKeywords = sortedByImportanceKeywords.sort(
                (a, b) => b.heading_presence - a.heading_presence
            );
            break;

        case optimizerKeywordsSortKeys.unused:
            sortedKeywords = sortedByImportanceKeywords.sort((a, b) => {
                if (a.used && !b.used) {
                    return 1;
                }
                if (!a.used && b.used) {
                    return -1;
                }
                return 0;
            });
            break;

        default:
            sortedKeywords = keywords;
    }

    // Move all ignored keywords to the end of the list
    const activeKeywords = sortedKeywords.filter((keyword) => !keyword?.removed);
    const ignoredKeywords = sortedKeywords.filter((keyword) => keyword?.removed);

    return [...activeKeywords, ...ignoredKeywords];
};
